"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _responsive = require("../../hooks/responsive");

var MobileSwitch = function MobileSwitch(_ref) {
  var mobile = _ref.mobile,
      children = _ref.children,
      eventReport = _ref.eventReport;
  var isMobile = (0, _responsive.useMobileWall)();
  (0, _react.useEffect)(function () {
    if (eventReport) {
      eventReport();
    }
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, isMobile && !!mobile ? mobile : children);
};

var _default = MobileSwitch;
exports["default"] = _default;
//# sourceMappingURL=index.js.map